import _ from 'lodash'

// let resultCount = 3 // same as in analyzeTerms on backend

export let termKeyPrefix = 'term_'

let getCitySummaries = ({ termsArray, results }) => {
  let summary = _(results)
    .groupBy(r => `${r.city}-${r.stateCode}-${r.queryFormatId}`)
    .map((cityResults, resultId) => {
      let [{ city, stateCode, queryFormatId }] = cityResults
      let places = _(cityResults)
        .map('result')
        .flatten()
        .uniqBy('placeId')
        .value()

      let data = _.transform(places, (acc, { name, website, url, placeId }) => {
        let place = { name, website, url, placeId }
        _.forEach(termsArray, term => {
          let foundIndex = _.findIndex(_.find(cityResults, { term }).result, {
            placeId,
          })
          let rank = foundIndex >= 0 ? foundIndex + 1 : null
          place[`${termKeyPrefix}${term}`] = rank
        })

        place.rankedCount = _(place)
          .pickBy((val, key) => key.startsWith(termKeyPrefix))
          .values()
          .transform(
            (acc, val) => {
              if (_.isFinite(val)) {
                acc.count += 1
              }
            },
            { count: 0 }
          )
          .get('count')

        place.hasPotential =
          !website && place.rankedCount / termsArray.length >= 0.5

        acc.push(place)
      })

      return {
        city,
        stateCode,
        resultId,
        data,
        queryFormatId,
      }
    })
    .value()

  return summary
}

export default getCitySummaries
